import { Container, DisplayObject, Text } from "pixi.js"

// Recursively destroy the canvas-backed textures of every PIXI Text in a subtree.
//
// A `Text` owns its own canvas-backed texture (one BaseTexture per instance, allocated when it
// rasterizes), so destroying it with { texture: true } frees that GPU texture safely. Everything
// else -- Sprites/BasicSprites/DynamicText backdrops -- may reference SHARED textures (spritesheet
// frames, Texture.WHITE), so we deliberately leave their textures alone: destroying a shared texture
// nulls its `orig` and crashes every other user in calculateVertices ("reading 'width'").
//
// Use this before removeChildren()/teardown of any UI container that builds Text via TextRenderer,
// so the per-instance Text textures don't leak (they are not reclaimed by GC -- Pixi needs an
// explicit destroy).
export const disposeTextTextures = (node?: DisplayObject): void => {
    if (!node) {
        return
    }
    if (node instanceof Text) {
        if (!node.destroyed) {
            node.destroy({ texture: true, baseTexture: true })
        }
        return
    }
    const children = (node as Container).children
    if (children && children.length) {
        // Copy first: destroying a child mutates the live children array.
        for (const child of [...children]) {
            disposeTextTextures(child)
        }
    }
}
